
import { Route } from 'react-router-dom';

import PublicReportPage from '../../features/AdminDashboard/Pages/PublicReportPage';

import ReportPermissionRoute from '../ReportPermissionRoute';
import { reportRoutes } from './reportRoutes';

const PublicReportRoutes = () => {
  return (
    <>
      {/* Public Reports landing page */}
      <Route
        path="/public-report"
        element={
          <ReportPermissionRoute
            requiredPermission="PublicReport"
            deniedTo="/404"
          >
            <PublicReportPage />
          </ReportPermissionRoute>
        }
      />

      {/* Individual reports - permission-based access */}
      {reportRoutes.map((report) => (
        <Route
          key={report.path}
          path={report.path}
          element={
            <ReportPermissionRoute
              requiredPermission={report.permission}
              deniedTo="/404"
            >
              {report.element}
            </ReportPermissionRoute>
          }
        />
      ))}
    </>
  );
};

export default PublicReportRoutes;
